// import { NotificationsSection } from "@/components/dashboard/NotificationsSection"
import { useEffect, useState } from "react"
import { AlertCircle } from "react-feather"
import { useCheckStripePaymentMethod, useOwnerSummary } from "@/api/generated/endpoints/api"
import { PendingTasksSection } from "@/components/dashboard/PendingTasksSection"
import { ServiceUsageSection } from "@/components/dashboard/ServiceUsageSection"
import { Header } from "@/components/layouts/header"
import { PaymentMethodRequiredDialog } from "@/components/payment/PaymentMethodRequiredDialog"
import { Alert, AlertContent, AlertIcon, AlertTitle } from "@/components/ui/alert"
import { useIsEchoesOwner } from "@/store/session"

export function DashboardPage() {
  const isEchoesOwner = useIsEchoesOwner()
  const { data: summary, isLoading } = useOwnerSummary()
  // セッションは Redis にキャッシュされ更新が遅れるため、毎回取得する summary の値で判定する。
  const isEchoesSyncFailed = Boolean(summary?.echoesFailedAt)
  const { data: paymentMethodData } = useCheckStripePaymentMethod({
    query: { enabled: !isEchoesOwner },
  })

  // ダイアログの開閉状態を管理
  const [isPaymentDialogOpen, setIsPaymentDialogOpen] = useState(false)

  // paymentMethodDataが取得されたらダイアログを表示
  useEffect(() => {
    if (isEchoesOwner) {
      setIsPaymentDialogOpen(false)
      return
    }
    if (paymentMethodData?.hasPaymentMethod === false) {
      setIsPaymentDialogOpen(true)
    }
  }, [isEchoesOwner, paymentMethodData])

  return (
    <>
      <Header />
      <div className="min-h-screen mt-[60px]">
        {/* Main Content */}
        <div className="space-y-8">
          {/* Echoes 同期失敗の警告(owner.echoes_failed_at あり) */}
          {isEchoesSyncFailed && (
            <Alert variant="destructive">
              <AlertIcon>
                <AlertCircle className="h-5 w-5" />
              </AlertIcon>
              <AlertContent>
                <AlertTitle>エコーズ連携に失敗しています</AlertTitle>
              </AlertContent>
            </Alert>
          )}

          {/* TODO: フェーズ3 */}
          {/* Notifications Section */}
          {/* <NotificationsSection /> */}

          {/* Pending Tasks Section */}
          <PendingTasksSection ticketCounts={summary?.ticketCounts} isLoading={isLoading} />

          {/* Divider */}
          <div className="border-t border-slate-200" />

          {/* Service Usage Section */}
          <ServiceUsageSection summary={summary} isLoading={isLoading} />
        </div>
      </div>

      <PaymentMethodRequiredDialog
        open={isPaymentDialogOpen}
        onOpenChange={setIsPaymentDialogOpen}
      />
    </>
  )
}
